export class InvGeneralDeftLogEntity{
    
    id:number;
    userId:number;
    dateDelete:string;
    partNumber:string;
    location:string;
    warehouse:string;
    constructor (){}
}
